import React from 'react';

import { ProfileEditForm, ProfileEditFormProps } from './ProfileEditForm';

/**
 * Props for OrgProfileEditForm (excludes `type` since it's fixed to 'organization')
 */
export type OrgProfileEditFormProps = Omit<ProfileEditFormProps, 'type'>;

/**
 * Organization profile edit form
 *
 * Modal form for editing organization profile picture and name.
 * Thin wrapper around ProfileEditForm with type="organization".
 *
 * Features:
 * - Profile picture upload with delete support
 * - Organization name text input
 * - Loading states for both operations
 * - Disabled submit when no changes made
 *
 * Used in:
 * - OrganizationSettingsCards via ScanSettingCard editConfig
 *
 * @see ProfileEditForm for implementation details
 */
export const OrgProfileEditForm: React.FC<OrgProfileEditFormProps> = props => (
  <ProfileEditForm type="organization" {...props} />
);
